import React, { useState } from 'react'

import Header from '../../components/HeaderNoMenu'
import FilterResult from '../../components/FilterResult'
import FilterImage from '../../assets/filter.png'
import Accordion from '@mui/material/Accordion'
import AccordionSummary from '@mui/material/AccordionSummary'
import AccordionDetails from '@mui/material/AccordionDetails'
import { HiOutlineChevronDown } from 'react-icons/hi'
import { IoIosAirplane } from 'react-icons/io'
import Latam from '../../assets/te.png'
import Typography from '@mui/material/Typography'
import { IoIosArrowDown } from 'react-icons/io'
import { HiInformationCircle } from 'react-icons/hi'
import {
  Container, H3, DivBuscaled, Passagem, ConteudoDaPassagem,
  Button, Airplane, AirTicketInstruction, CheckboxContainer, Radio,
  Img, Line, Cidade, Direto, Rate, ContainerRate, Filtering
} from './styles'


export default function SearchResultTravel() {
  const [open, setOpen] = useState(false)
  const [filter, setFilter] = useState(false)

  function openAndClose() {
    setFilter(!filter)
  }
  function handleClick() {
    setOpen(!open)
  }

  return (
    <>
      <Header />
      <Container>
        <H3>Resultado de busca</H3>

        {filter && (<FilterResult openFilter={openAndClose} />)}
        <DivBuscaled>
          <Accordion sx={{ boxShadow: 0 }} className="accordion">
            <AccordionSummary
              expandIcon={<HiOutlineChevronDown />}
              aria-controls="panel1a-content"
              id="panel1a-header"
            >
              <Typography className="title">Refazer busca</Typography>
            </AccordionSummary>
            <AccordionDetails>
              <p>Contéudo</p>
            </AccordionDetails>
          </Accordion>
          <Filtering isBack={!!filter} onClick={openAndClose} >
            <img src={FilterImage} alt="imagem do Filtro" />
            <p>Filtrar</p>
          </Filtering >

        </DivBuscaled>
        <Passagem>
          <ConteudoDaPassagem>
            <p className="tarifa">Tarifa por adulto</p>
            <p className="value">13.000<span>Pts</span></p>
          </ConteudoDaPassagem>
          <Button>COMPRAR</Button>
        </Passagem>
        <Airplane>
          <div className="padding">
            <p><IoIosAirplane className="volta" /> Ida <span>Sexta-feira 25/10/2019</span></p>
          </div>
        </Airplane>

        <AirTicketInstruction>
          <CheckboxContainer>
            <Radio type="radio" name="order" id="radio1" value="relevant" />
            <Img src={Latam} />
          </CheckboxContainer>
          <Cidade>
            <p>GRU</p>
            <p className="cidadeColor">são paulo:</p>
            <p>00:30</p>
          </Cidade>
          <Direto>
            <Line></Line>
            <p>Direto</p>
          </Direto>
          <Cidade>
            <p>GRU</p>
            <p className="cidadeColor">são paulo: <HiInformationCircle className="icon" /></p>
            <p>00:30</p>
          </Cidade>
        </AirTicketInstruction>

        <AirTicketInstruction>
          <CheckboxContainer>
            <Radio type="radio" name="order" id="radio2" value="relevant" />
            <Img src={Latam} alt="" />
          </CheckboxContainer>
          <Cidade>
            <p>GRU</p>
            <p className="cidadeColor">são paulo:</p>
            <p>00:30</p>
          </Cidade>
          <Direto>
            <Line></Line>
            <p>Direto</p>
          </Direto>
          <Cidade>
            <p>GRU</p>
            <p className="cidadeColor">são paulo: <HiInformationCircle className="icon" /></p>
            <p>00:30</p>
          </Cidade>
        </AirTicketInstruction>

        <Airplane>
          <div className="padding">
            <p><IoIosAirplane className="ida" /> Volta <span>Sexta-feira 25/10/2019</span></p>
          </div>
        </Airplane>

        <AirTicketInstruction>
          <CheckboxContainer>
            <Radio type="radio" name="order" id="radio1" value="relevant" />
            <Img src={Latam} />
          </CheckboxContainer>
          <Cidade>
            <p>GRU</p>
            <p className="cidadeColor">são paulo:</p>
            <p>00:30</p>
          </Cidade>
          <Direto>
            <Line></Line>
            <p>Direto</p>
          </Direto>
          <Cidade>
            <p>GRU</p>
            <p className="cidadeColor">são paulo: <HiInformationCircle className="icon" /></p>
            <p>00:30</p>
          </Cidade>
        </AirTicketInstruction>

        <AirTicketInstruction>
          <CheckboxContainer>
            <Radio type="radio" name="order" id="radio2" value="relevant" />
            <Img src={Latam} alt="" />
          </CheckboxContainer>
          <Cidade>
            <p>GRU</p>
            <p className="cidadeColor">são paulo:</p>
            <p>00:30</p>
          </Cidade>
          <Direto>
            <Line></Line>
            <p>Direto</p>
          </Direto>
          <Cidade>
            <p>GRU</p>
            <p className="cidadeColor">são paulo: <HiInformationCircle className="icon" /></p>
            <p>00:30</p>
          </Cidade>
        </AirTicketInstruction>
        <Rate onClick={handleClick}>
          <p>Ver taxas inclusas</p>
          <IoIosArrowDown />
          {open &&
            <ContainerRate>
              <p>Adulto (1)<span>R$ 439,80</span></p>
              <p>Taxa de embarque <span>R$ 50,19</span></p>
              <p>Encargos <span>R$ 439,80</span></p>
              <p>Total <span>R$ 439,80</span></p>
            </ContainerRate>
          }
        </Rate>
      </Container>
    </>

  )
}
